import React from 'react';
import styled from '@grebban/style-system-react';
import Text from 'components/Text';
import type { HighlightedTextBlock } from 'libs/sanity/types/generated';
import { above } from '@fogia/core-web/utils/mediaqueries';

const Wrapper = styled('div')`
    background: var(--ui-background);
    color: var(--ui-primary-aa);
    display: flex;
    flex-direction: column;
    padding-right: 7px;

    ${above['tablet.lg']} {
        padding-right: 20px;
    }
`;

const FancyQuote = styled('blockquote')`
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-style: normal;
    margin: 0;
    padding: 0;

    ${above['tablet.lg']} {
        gap: 15px;
    }
`;

const TagGroup = styled('div')`
    display: flex;
    flex-direction: column;
`;

export interface HighlightedTextComponentProps {
    highlightedText?: HighlightedTextBlock['highlightedText'];
    name?: HighlightedTextBlock['name'];
    affiliation?: HighlightedTextBlock['affiliation'];
}

const HighlightedTextComponent = ({ highlightedText, name, affiliation, ...rest }: HighlightedTextComponentProps) => {
    const shouldShowQuote = Boolean(name);
    const displayText = highlightedText
        ? `${shouldShowQuote ? '“' : ''}${highlightedText}${shouldShowQuote ? '”' : ''}`
        : '';

    return (
        <Wrapper className="HighlightedText" {...rest}>
            <FancyQuote>
                {displayText && (
                    <Text typography={['Primary/24_110_510_-3', null, null, 'Primary/30_100_510_-5']} m="0">
                        {displayText}
                    </Text>
                )}
                {(name || affiliation) && (
                    <TagGroup>
                        {name && (
                            <Text
                                typography={['Secondary/Mobile/18_120_400_-1', null, null, 'Secondary/20_120_400_-1']}
                                m="0"
                            >
                                {name}
                            </Text>
                        )}
                        {affiliation && (
                            <Text
                                typography={['Secondary/Mobile/18_120_400_-1', null, null, 'Secondary/20_120_400_-1']}
                                m="0"
                            >
                                {affiliation}
                            </Text>
                        )}
                    </TagGroup>
                )}
            </FancyQuote>
        </Wrapper>
    );
};

export default HighlightedTextComponent;
